import React from 'react';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';

const TermsAndConditions = () => {
  const { appId } = useParams();

  // This would typically fetch the terms content from an API or database
  const getTermsContent = (appId) => {
    // Example content - in a real app, this would come from a database or API
    const terms = {
      'app1': {
        title: 'App 1 Terms and Conditions',
        content: '<h2>Introduction</h2><p>These are the terms and conditions for App 1...</p><ul><li>Term 1</li><li>Term 2</li></ul>'
      },
      'app2': {
        title: 'App 2 Terms and Conditions',
        content: '<h2>Introduction</h2><p>These are the terms and conditions for App 2...</p><ul><li>Term 1</li><li>Term 2</li></ul>'
      }
    };

    return terms[appId] || {
      title: 'Terms and Conditions',
      content: '<p>No terms and conditions found for this app.</p>'
    };
  };

  const terms = getTermsContent(appId);
  const sanitizedContent = DOMPurify.sanitize(terms.content);

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h1 className="text-2xl font-bold mb-4">{terms.title}</h1>
      <div 
        className="prose max-w-none"
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
    </div>
  );
};

export default TermsAndConditions; 